import {Component} from '@angular/core';

@Component({
  selector: 'cm-products-bidder-summary',
  template: `
    <div>
      <cm-topbar title="Bidder"></cm-topbar>
      <div class="main-content">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-12 col-md-8 col-lg-4">
              <mat-card class="text-center">
                <mat-card-title class="mb-4">
                  <img src="assets/images/icons/icon_bidder_step_7.svg" alt="" class="mb-4"/>
                  <h3>Done!</h3> 
                </mat-card-title>
                <mat-card-content>
                  <h6 class="mb-3">Your request has been sent successfully and will be processed shortly.</h6>
                </mat-card-content>
              </mat-card>
              <div class="mat-card-outer-controls text-center">
                <button mat-raised-button color="primary"
                        routerLink="/inventory/bidder/requested"
                        class="large mb-3">
                  Go to my request list
                </button>
                <br>
                <button mat-button color="primary" routerLink="/products">
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
})
export class ProductsBidderSummaryComponent {


}
